export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAIL = "LOGIN_FAIL";

export const REFRESH_SUCCESS = "REFRESH_SUCCESS";
export const REFRESH_FAIL = "REFRESH_FAIL";

export const LOGOUT = "LOGOUT";

export const PERMISSIONS_FETCH_START = "PERMISSIONS_FETCH_START";
export const PERMISSIONS_FETCH_SUCCESS = "PERMISSIONS_FETCH_SUCCESS";
export const PERMISSIONS_FETCH_FAIL = "PERMISSIONS_FETCH_FAIL";
export const PERMISSIONS_FRUIT_MODE = "PERMISSIONS_FRUIT_MODE";
export const PERMISSIONS_RESET = "PERMISSIONS_RESET";

export const SET_MESSAGE = "SET_MESSAGE";
export const CLEAR_MESSAGE = "CLEAR_MESSAGE";

export const SHOW_IMAGE_BACKDROP = "SHOW_IMAGE_BACKDROP";
export const CLOSE_IMAGE_BACKDROP = "CLOSE_IMAGE_BACKDROP";
// Users
export const RETRIEVE_USERS = "RETRIEVE_USERS";
export const RETRIEVE_LOGGEDIN_USER = "RETRIEVE_LOGGEDIN_USER";
export const CREATE_USER = "UPDATE_USER";
export const UPDATE_USER = "CREATE_USER";
export const DELETE_USER = "DELETE USER";
export const RESTORE_USER = "RESTORE_USER";
export const UPDATE_USER_STATUS = "UPDATE_USER_STATUS";

// Products
export const RETRIEVE_PRODUCTS = "RETRIEVE_PRODUCTS";
export const RETRIEVE_PRODUCT_VIEW = "RETRIEVE_PRODUCT_VIEW";
export const CREATE_PRODUCT = "CREATE_PRODUCT";
export const UPDATE_PRODUCT = "UPDATE_PRODUCT";
export const DELETE_PRODUCT = "DELETE_PRODUCT";
export const RESTORE_PRODUCT = "RESTORE_PRODUCT";
export const UPDATE_PRODUCT_STATUS = "UPDATE_PRODUCT_STATUS";
export const RETRIEVE_SALE_PRODUCTS = "RETRIEVE_SALE_PRODUCTS";

// Reward
export const RETRIEVE_REWARDS = "RETRIEVE_REWARDS";
export const TOGGLE_COMPANION = "TOGGLE_COMPANION";


// Orders
export const RETRIEVE_ORDERS = "RETRIEVE_ORDERS";
export const RETRIEVE_ORDER_VIEW = "RETRIEVE_ORDER_VIEW";
export const UPDATE_ORDER_STATUS = "UPDATE_ORDER_STATUS";
export const DELETE_ORDER = "DELETE_ORDER";
export const RESTORE_ORDER = "RESTORE_ORDER";

// Refund
export const RETRIEVE_REFUNDS = "RETRIEVE_REFUNDS";
export const RETRIEVE_REFUND_VIEW = "RETRIEVE_REFUND_VIEW";
export const UPDATE_REFUND_STATUS = "UPDATE_REFUND_STATUS";
export const DELETE_REFUND = "DELETE_REFUND";
export const RESTORE_REFUND = "RESTORE_REFUND";

// Cart 
export const RETRIEVE_CARTS = "RETRIEVE_CARTS";

// Categories
export const RETRIEVE_CATEGORIES = "RETRIEVE_CATEGORIES";
export const VIEW_CATEGORY = "VIEW_CATEGORY";
export const CREATE_CATEGORY = "CREATE_CATEGORY";
export const UPDATE_CATEGORY = "UPDATE_CATEGORY";
export const DELETE_CATEGORY = "DELETE_CATEGORY";
export const RESTORE_CATEGORY = "RESTORE_CATEGORY";

export const UPDATE_SETTINGS = "UPDATE_SETTINGS";

// referral
export const RETRIEVE_REFERRAL = "RETRIEVE_REFERRAL";

// Contact
export const RETRIEVE_CONTACTS = "RETRIEVE_CONTACTS";
export const RETRIEVE_CONTACT_VIEW = "RETRIEVE_CONTACT_VIEW";
export const UPDATE_CONTACT_STATUS = "UPDATE_CONTACT_STATUS";

// Chat
export const RETRIEVE_CONVERSATIONS = "RETRIEVE_CONVERSATIONS";
export const RETRIEVE_CONVERSATION = "RETRIEVE_CONVERSATION";
export const SEND_MESSAGE = "SEND_MESSAGE";
export const MARK_MESSAGE_READ = "MARK_MESSAGE_READ";
export const RETRIEVE_UNREAD_COUNT = "RETRIEVE_UNREAD_COUNT";
